/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Toolbar_Decrease_IndentInputs */



/**
* | output |
* | --- |
* | "Decrease Indent" |
*
* @param {Editor_Toolbar_Decrease_IndentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_toolbar_decrease_indent = /** @type {((inputs?: Editor_Toolbar_Decrease_IndentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Toolbar_Decrease_IndentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzug verringern")
	return /** @type {LocalizedString} */ ("Decrease Indent")
});